<mat-toolbar class="app-header">
    <!-- Hamburger menu -->
    <button mat-icon-button [matMenuTriggerFor]="getActiveMenu()" (menuOpened)="onNavMenuOpened()" class="menu-btn"
            aria-label="Navigation menu" matTooltip="Menu">
        <mat-icon>menu</mat-icon>
    </button>

    <!-- Empty / fallback menus -->
    <mat-menu #emptyMenu="matMenu" class="nav-menu-panel"></mat-menu>
    <!-- ═══════════════════════════════════════════════════ ACCOUNTANT MENU -->
    <mat-menu #accountantMenu="matMenu" class="nav-menu-panel">
        <div class="menu-section-header" (click)="$event.stopPropagation()">
            <mat-icon>dashboard</mat-icon> Navigation
        </div>

        <button mat-menu-item routerLink="/accountant/dashboard" routerLinkActive="active">
            <mat-icon>dashboard</mat-icon>
            <span>Dashboard</span>
        </button>

        <mat-divider></mat-divider>

        <button mat-menu-item routerLink="/accountant/settings" routerLinkActive="active">
            <mat-icon>business_center</mat-icon>
            <span>Firm Profile</span>
        </button>
    </mat-menu>

    <!-- ═══════════════════════════════════════════════════ CLIENT MENU -->
    <!-- NUC-430: one sectioned panel (was a flat list + a 'Settings' fly-out).
         Section headers mirror the admin menu's *ngIf — a header is hidden when
         NONE of its items are permitted. Each item keeps its original gate. -->
    <mat-menu #clientMenu="matMenu" class="nav-menu-panel">

        <!-- ── OVERVIEW ──────────────────────────────────────────────── -->
        <div class="menu-section-header menu-section-toggle" (click)="toggleNavSection('overview', $event)"
             *ngIf="permissionChecker.hasAccessToDashboard() || permissionChecker.hasRoleClient()">
            <mat-icon>dashboard</mat-icon> <span class="section-label">Overview</span>
            <mat-icon class="section-chevron">{{ isNavSectionOpen('overview') ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <ng-container *ngIf="isNavSectionOpen('overview')">
            <button mat-menu-item routerLink="/client/dashboard" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToDashboard()">
                <mat-icon>dashboard</mat-icon>
                <span>Dashboard</span>
            </button>

            <!-- TODO NUC-269: client "Reports" hub has no dedicated catalog capability;
                 left role-gated until a report screen cap is defined. -->
            <button mat-menu-item routerLink="/client/reports" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasRoleClient()">
                <mat-icon>summarize</mat-icon>
                <span>Reports</span>
            </button>
        </ng-container>

        <!-- ── BOOKKEEPING ───────────────────────────────────────────── -->
        <div class="menu-section-header menu-section-toggle" (click)="toggleNavSection('bookkeeping', $event)"
             *ngIf="permissionChecker.hasAccessToBankStatements() || permissionChecker.hasAccessToTransactions() || permissionChecker.hasAccessToExpenses() || permissionChecker.hasAccessToInvoices() || permissionChecker.hasAccessToDocuments()">
            <mat-icon>menu_book</mat-icon> <span class="section-label">Bookkeeping</span>
            <mat-icon class="section-chevron">{{ isNavSectionOpen('bookkeeping') ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <ng-container *ngIf="isNavSectionOpen('bookkeeping')">
            <button mat-menu-item routerLink="/client/bank-statements" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToBankStatements()">
                <mat-icon>account_balance</mat-icon>
                <span>Bank Statements</span>
            </button>

            <button mat-menu-item routerLink="/client/transactions" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToTransactions()">
                <mat-icon>swap_horiz</mat-icon>
                <span>Transactions</span>
            </button>

            <button mat-menu-item routerLink="/client/expenses" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToExpenses()">
                <mat-icon>receipt_long</mat-icon>
                <span>Expenses</span>
            </button>

            <button mat-menu-item routerLink="/client/invoices" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToInvoices()">
                <mat-icon>request_quote</mat-icon>
                <span>Invoices</span>
            </button>

            <button mat-menu-item routerLink="/client/documents" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToDocuments()">
                <mat-icon>folder</mat-icon>
                <span>Documents</span>
            </button>
        </ng-container>

        <!-- ── ACCOUNTING & INTEGRATIONS ─────────────────────────────── -->
        <div class="menu-section-header menu-section-toggle" (click)="toggleNavSection('accounting', $event)"
             *ngIf="permissionChecker.hasAccessToFinancialAccounts() || permissionChecker.hasRoleClient() || permissionChecker.hasAccessToCategoryMapping() || permissionChecker.hasAccessToExpenseRules() || permissionChecker.hasAccessToTransactionRules()">
            <mat-icon>account_balance</mat-icon> <span class="section-label">Accounting &amp; Integrations</span>
            <mat-icon class="section-chevron">{{ isNavSectionOpen('accounting') ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <ng-container *ngIf="isNavSectionOpen('accounting')">
            <button mat-menu-item routerLink="/client/financial-accounts" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToFinancialAccounts()">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Financial Accounts</span>
            </button>

            <!-- TODO NUC-269: client "Connected Apps" has no dedicated catalog
                 capability (distinct from admin integration-instance); left
                 role-gated until a client-integrations screen cap is defined. -->
            <button mat-menu-item routerLink="/client/connected-apps" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasRoleClient()">
                <mat-icon>extension</mat-icon>
                <span>Connected Apps</span>
            </button>

            <!-- Category Mapping is a sibling of Connected Apps (both plain items in this section),
                 so Connected Apps isn't rendered as both a page and a parent node. -->
            <button mat-menu-item routerLink="/client/category-mapping" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToCategoryMapping()">
                <mat-icon>label</mat-icon>
                <span>Category Mapping</span>
            </button>

            <button mat-menu-item routerLink="/client/expense-mapping-rules" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToExpenseRules()">
                <mat-icon>tune</mat-icon>
                <span>Expense Override Rules</span>
            </button>

            <button mat-menu-item routerLink="/client/transaction-mapping-rules" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToTransactionRules()">
                <mat-icon>rule</mat-icon>
                <span>Transaction Mapping Rules</span>
            </button>
        </ng-container>

        <!-- ── SETUP ─────────────────────────────────────────────────── -->
        <div class="menu-section-header menu-section-toggle" (click)="toggleNavSection('setup', $event)"
             *ngIf="permissionChecker.hasRoleClient() || permissionChecker.hasAccessToFiscalYears()">
            <mat-icon>settings</mat-icon> <span class="section-label">Setup</span>
            <mat-icon class="section-chevron">{{ isNavSectionOpen('setup') ? 'expand_less' : 'expand_more' }}</mat-icon>
        </div>
        <ng-container *ngIf="isNavSectionOpen('setup')">
            <!-- TODO NUC-269: business-profile settings has no dedicated catalog
                 capability; left role-gated until a settings screen cap is defined. -->
            <button mat-menu-item routerLink="/client/settings" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasRoleClient()">
                <mat-icon>business_center</mat-icon>
                <span>Business Profile</span>
            </button>

            <button mat-menu-item routerLink="/client/fiscal-years" routerLinkActive="active"
                    [disabled]="!permissionChecker.hasAccessToFiscalYears()">
                <mat-icon>date_range</mat-icon>
                <span>Fiscal Years</span>
            </button>
        </ng-container>
    </mat-menu>

    <!-- ═══════════════════════════════════════════════════ ADMIN MENU -->
    <mat-menu #adminMenu="matMenu" class="nav-menu-panel">
        <button mat-menu-item [matMenuTriggerFor]="administrationmenu">
            <mat-icon>admin_panel_settings</mat-icon>
            <span>Administration</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="reportsmenu">
            <mat-icon>assessment</mat-icon>
            <span>Reports</span>
        </button>
    </mat-menu>

    <!-- Auditor menu -->
    <mat-menu #auditorMenu="matMenu" class="nav-menu-panel">
        <button mat-menu-item [matMenuTriggerFor]="administrationmenu">
            <mat-icon>admin_panel_settings</mat-icon>
            <span>Administration</span>
        </button>
        <button mat-menu-item [matMenuTriggerFor]="reportsmenu">
            <mat-icon>assessment</mat-icon>
            <span>Reports</span>
        </button>
    </mat-menu>

    <mat-menu #administrationmenu="matMenu" class="nav-menu-panel">
        <button mat-menu-item routerLink="/administration/dashboard" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToDashboard()">
            <mat-icon>dashboard</mat-icon><span>Dashboard</span>
        </button>
        <button mat-menu-item routerLink="/administration/users" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToViewUsers()">
            <mat-icon>people</mat-icon><span>Users</span>
        </button>
        <button mat-menu-item routerLink="/administration/mfa" routerLinkActive="active" *ngIf="canManageMfa()">
            <mat-icon>verified_user</mat-icon><span>Two-Step Verification</span>
        </button>
        <button mat-menu-item routerLink="/administration/tax-codes" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToTaxCodes()">
            <mat-icon>receipt</mat-icon><span>Tax Codes</span>
        </button>
        <button mat-menu-item routerLink="/administration/reference-data" routerLinkActive="active"
                *ngIf="permissionChecker.hasAccessToManageReferenceData()">
            <mat-icon>category</mat-icon><span>Reference Data</span>
        </button>
        <button mat-menu-item routerLink="/administration/org-units" routerLinkActive="active" *ngIf="permissionChecker.hasAccessToOrgUnits()">
            <mat-icon>account_tree</mat-icon><span>Org Units</span>
        </button>
        <mat-divider *ngIf="permissionChecker.hasAccessToSystemProperty()"></mat-divider>
        <button mat-menu-item routerLink="/settings/system-properties" routerLinkActive="active"
                *ngIf="permissionChecker.hasAccessToSystemProperty()"
                [disabled]="!permissionChecker.hasAccessToSystemProperty()">
            <mat-icon>tune</mat-icon><span>System Properties</span>
        </button>
        <button mat-menu-item routerLink="/administration/integration-instances" routerLinkActive="active"
                *ngIf="permissionChecker.hasAccessToIntegrationInstance()">
            <mat-icon>extension</mat-icon><span>Integrations</span>
        </button>
        <button mat-menu-item routerLink="/administration/workflow-secrets" routerLinkActive="active"
                *ngIf="permissionChecker.hasAccessToWorkflowSecrets()"
                [disabled]="!permissionChecker.hasAccessToWorkflowSecrets()">
            <mat-icon>vpn_key</mat-icon><span>Workflow Secrets</span>
        </button>
        <!-- DevOps/monitoring moved to the ops console: Service Monitor, Execution Monitor,
             IP Blocklist, Logs (Log Explorer / Session Recordings), Performance. -->
    </mat-menu>

    <mat-menu #reportsmenu="matMenu" class="nav-menu-panel">
        <button mat-menu-item routerLink="/reports/audit-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToAuditReport()">
            <mat-icon>policy</mat-icon><span>Audit Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/mail-report" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToMailReport()">
            <mat-icon>email</mat-icon><span>Mail Report</span>
        </button>
        <button mat-menu-item routerLink="/reports/mail-templates" routerLinkActive="active" [disabled]="!permissionChecker.hasAccessToMailTemplates()">
            <mat-icon>mail</mat-icon><span>Mail Templates</span>
        </button>
    </mat-menu>

    <!-- ═══════════════════════════════════════════ HEADER RIGHT SIDE -->
    <span class="app-title">BookWise</span>
    <span class="header-spacer"></span>

    <div class="header-actions">
        <!-- App switcher — shown to anyone with the console:access capability
             (ROLE_ADMIN / ROLE_DEVOPS satisfy it via the dual-accept escape
             hatch). SSO is shared across <tenant> and console.<tenant>, so this
             is a plain top-level navigation that re-auths silently. -->
        <button *ngIf="canSwitchToConsole()" mat-icon-button (click)="switchToConsole()"
                class="header-icon-btn" matTooltip="Switch to console">
            <mat-icon>swap_horiz</mat-icon>
        </button>

        <button mat-icon-button (click)="navigate('/')" matTooltip="Dashboard">
            <mat-icon>dashboard</mat-icon>
        </button>

        <!-- Theme toggle -->
        <button mat-icon-button (click)="themeService.toggle()" class="header-icon-btn"
                [matTooltip]="themeService.isDark() ? 'Light mode' : 'Dark mode'">
            <mat-icon>{{ themeService.isDark() ? 'light_mode' : 'dark_mode' }}</mat-icon>
        </button>

        <button mat-icon-button [matMenuTriggerFor]="helpMenu"
                matTooltip="Help &amp; Info" class="header-icon-btn">
            <mat-icon>help_outline</mat-icon>
        </button>
        <mat-menu #helpMenu="matMenu" class="nav-menu-panel">
            <div class="menu-section-header" (click)="$event.stopPropagation()">
                <mat-icon>help_outline</mat-icon> Help &amp; Info
            </div>
            <button mat-menu-item (click)="showAbout()">
                <mat-icon>info</mat-icon><span>About</span>
            </button>
            <button mat-menu-item (click)="showSupport()">
                <mat-icon>support_agent</mat-icon><span>Support</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="showPrivacy()">
                <mat-icon>privacy_tip</mat-icon><span>Privacy Policy</span>
            </button>
            <button mat-menu-item (click)="showTerms()">
                <mat-icon>gavel</mat-icon><span>Terms of Service</span>
            </button>
        </mat-menu>

        <div class="header-separator"></div>

        <!-- User info + context menu -->
        <button mat-button [matMenuTriggerFor]="userContextMenu" class="user-menu-btn">
            <div class="user-info">
                <span class="user-name">{{ user.name || appConfigService.getUserId() }}</span>
                <span class="user-role">{{ getActiveRoleLabel() }}</span>
            </div>
            <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #userContextMenu="matMenu" class="nav-menu-panel">
            <div class="menu-section-header" (click)="$event.stopPropagation()">
                <mat-icon>account_circle</mat-icon>
                {{ user.username || appConfigService.getUserId() }}
            </div>
            <button mat-menu-item (click)="onEditProfile()">
                <mat-icon>person</mat-icon>
                <span>Edit Profile</span>
            </button>
            <button mat-menu-item (click)="onChangePassword()">
                <mat-icon>lock</mat-icon>
                <span>Change Password</span>
            </button>
            <button mat-menu-item (click)="onSecurity()">
                <mat-icon>shield</mat-icon>
                <span>Security</span>
            </button>
            <mat-divider></mat-divider>
            <button mat-menu-item (click)="onLogout()" class="menu-item-logout">
                <mat-icon>logout</mat-icon>
                <span>Logout</span>
            </button>
        </mat-menu>
    </div>
</mat-toolbar>
